<template>

	<div class="meal-menu-clone">

		<page-bar />

		<div class="row">

			<div class="col-md-10">

				<h3 class="page-title" v-translate>Duplicar cardápio</h3>

			</div>

			<div class="col-md-2">

				<router-link to="/meal-menu" class="btn btn-primary btn-block">
					Voltar
				</router-link>

			</div>

		</div>

		<div class="portlet light">

			<div class="portlet-body">

				<form role="form">

					<fieldset>

						<div class="row" v-if="mealMenuClone && mealMenuClone.length">

							<div class="col-md-12">

								<div class="note note-success">

									<h4 class="block" v-translate>Duplicando cardápio</h4>

									<p>
										{{ params.recipientGroup | enum('RecipientsGroupType') }}
										<span v-if="params.recipientGroup !== 'ALL_SCHOOL'">
											<span v-if="params.recipientGroup === 'PER_LEVEL'">
												({{ params.level | enum('SchoolClassLevelType') }})
											</span>
											<span v-if="params.recipientGroup === 'PER_GRADE'">
												({{ params.grade.level | enum('SchoolClassLevelType') }} >
												{{ params.grade.description }})
											</span>
											<span v-if="params.recipientGroup === 'PER_CLASS'">
												({{ params.schoolClass.schoolClassGrade.description }} >
												{{ params.schoolClass.description }})
											</span>
										</span>
										, <span v-translate>do periodo de </span>
										{{ params.startDate | date('DD') }}
										<span>à</span>
										{{ params.endDate | date('DD') }}
										<span>de</span>
										{{ params.month.value | enum('Month') }}
										<span>de</span>
										{{ params.year }}
									</p>

								</div>

							</div>

						</div>

						<div class="row">

							<div class="col-md-6">

								<recipients-group :label="'Selecione a configuração do cardápio'" :selected="recipientGroup" />

							</div>

							<div class="col-md-6">

								<class-level :label="'Selecione um nível de ensino'" :blacklist="['Fundamental_2', 'EnsinoMedio']" v-if="recipientGroup === 'PER_LEVEL'" />

								<class-grade :label="'Selecione um ano de ensino'" v-if="recipientGroup === 'PER_GRADE'" />

								<school-class :label="'Selecione uma turma'" :group="false" v-if="recipientGroup === 'PER_CLASS'" />

							</div>

						</div>

					</fieldset>

					<fieldset v-if="recipientGroup">

						<legend v-translate>Para qual semana deseja duplicar o cardápio?</legend>

						<div class="row">

							<div class="col-md-4">

								<year :label="'Ano letivo'" :group="false" />

							</div>

							<div class="col-md-4">

								<month :disabled="!year" :group="false" />

							</div>

							<div class="col-md-4">

								<week :show-first="false" :disabled="!year || !month || (month && month.index === -1)" :group="false" />

							</div>

						</div>

					</fieldset>

				</form>

			</div>

		</div>

		<div class="portlet light" v-show="mealMenuClone && mealMenuClone.length">

			<div class="portlet-title">

				<div class="row">

					<div class="col-md-offset-9 col-md-3">

						<div class="btn-group btn-group-justified" role="group">

							<a type="button" class="btn green-jungle" role="button" :disabled="!formIsValid()" @click="save">
								<i class="fa fa-floppy-o" aria-hidden="true"></i>
								<span v-translate>Salvar</span>
							</a>

						</div>

					</div>

				</div>

			</div>

			<div class="portlet-body" v-if="mealMenuClone && mealMenuClone.length">

				<div class="row">

					<div class="col-md-12">

						<div class="table-responsive">

							<table class="table table-bordered table-striped table-condensed table-layout-fixed">

								<thead>

									<tr class="bg-yellow-gold font-white">

										<th class="text-center" v-for="(item, $index) in mealMenuClone">
											{{ item.clonedDate | date('dddd') }}
										</th>

									</tr>

									<tr class="bg-grey">

										<th class="text-center" v-for="(item, $index) in mealMenuClone">

											<small>

												<span class="f-w-n" v-translate>Duplicar de</span>
												{{ item.clonedDate | date('DD/MM/YYYY') }}

												<span v-show="item.date">
													<span class="f-w-n" v-translate>para</span>
													<h4>{{ item.date | date('DD/MM/YYYY') }}</h4>
												</span>

											</small>

										</th>

									</tr>

									<tr>

										<th v-for="(item, $index) in mealMenuClone">

											<button type="button" v-if="item.times.length" class="btn btn-xs btn-block red-flamingo" @click="removeMealDay($index)">
												<i class="fa fa-times" aria-hidden="true"></i>
												Remover cardápio
											</button>

										</th>

									</tr>

								</thead>

								<tbody>

									<tr>

										<td v-for="(item, $index) in mealMenuClone">

											<div v-for="(meal, index) in item.times" role="form">

												<div class="well p-5">

													<div class="form-group">

														<label class="control-label"><small v-translate>Refeição</small></label>

														<select class="form-control input-sm" name="meal-type" v-model="meal.type" v-validate="'required'" :disabled="item.isBefore">
															<option value="" selected v-translate>Selecione</option>
															<option v-for="(value, index) in ENUM.MealTimeType" :value="index">{{ value }}</option>
														</select>

													</div>

													<div class="form-group">

														<label class="control-label"><small v-translate>Horário</small></label>
														<input type="text" class="form-control input-sm" name="meal-time" v-mask="'##:##'" v-model="meal.time" v-validate="{ rules: { required: true, regex: /([01]\d|2[0-3]):([0-5]\d)/} }" :disabled="item.isBefore">

													</div>

													<div class="form-group">

														<label class="control-label"><small v-translate>Alimento</small></label>
														<input type="text" class="form-control input-sm" name="meal-meal" v-model="meal.meal" :disabled="item.isBefore">

													</div>

													<div class="form-group">

														<label class="control-label"><small v-translate>Bebida e/ou fruta</small></label>
														<input type="text" class="form-control input-sm" name="meal-beverage" v-model="meal.beverage" :disabled="item.isBefore">

													</div>

													<div class="form-group m-b-0">

														<button type="button" class="btn btn-sm btn-block red-mint" @click="removeItem($index, index)" :disabled="item.isBefore">
															<i class="fa fa-trash" aria-hidden="true"></i>
															<span v-translate>Remover refeição</span>
														</button>

													</div>

												</div>

											</div>

											<div class="form-group m-b-0" v-show="!item.isBefore">

												<button type="button" class="btn btn-sm btn-block yellow-gold" @click="addItem($index)">
													<i class="fa fa-plus" aria-hidden="true"></i>
													<span v-translate>Adicionar refeição</span>
												</button>

											</div>

										</td>

									</tr>

								</tbody>

							</table>

						</div>

					</div>

					<div class="col-md-offset-9 col-md-3">

						<div class="btn-group btn-group-justified" role="group">

							<a type="button" class="btn green-jungle" role="button" :disabled="!formIsValid()" @click="save">
								<i class="fa fa-floppy-o" aria-hidden="true"></i>
								<span v-translate>Salvar</span>
							</a>

						</div>

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>

	import MealMenuClone from './';
	export default MealMenuClone;

</script>

<style lang="scss" scoped>

	.form-control-static {
		display: block;
	}

	.well:hover,
	.well:focus {
		background: #ccc;
		transition: 1s ease;
	}

	strong {
		color: #FF8900;
	}

</style>



// WEBPACK FOOTER //
// main.vue?718c6741